// This script initializes a light gallery with zoom and thumbnail plugins
// It uses the lightGallery library to create a responsive image gallery
// with zoom and thumbnail functionalities.
//
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

document.addEventListener('DOMContentLoaded', function() {
    // Common settings for all galleries
    const commonSettings = {
        plugins: [lgZoom, lgThumbnail],
        speed: 500,
        selector: 'a',
        download: false,
        backdropDuration: 400,
        thumbnail: true,
        animateThumb: true,
        showThumbByDefault: false,
        allowMediaOverlap: true,
        toggleThumb: true,
        licenseKey: 'license_key',
    };
    
    // Grid gallery specific settings
    const gridGalleries = document.querySelectorAll('[id^="grid-gallery-"]');
    gridGalleries.forEach(gallery => {
        lightGallery(gallery, {
            ...commonSettings,
            galleryId: 'grid-' + gallery.id,
            mode: 'lg-fade',
            cssEasing: 'cubic-bezier(0.25, 0, 0.25, 1)'
        });
    });

    // Masonry gallery specific settings
    const masonryGalleries = document.querySelectorAll('[id^="masonry-gallery-"]');
    masonryGalleries.forEach(gallery => {
        lightGallery(gallery, {
            ...commonSettings,
            galleryId: 'masonry-' + gallery.id,
            mode: 'lg-slide',
            cssEasing: 'ease-in-out'
        });
    });
    
    // Initialize any other galleries with the lightbox-gallery class
    // that aren't covered by the specific selectors above
    document.querySelectorAll('.lightbox-gallery').forEach(gallery => {
        if (!gallery.id.startsWith('grid-gallery-') && !gallery.id.startsWith('masonry-gallery-')) {
            lightGallery(gallery, commonSettings);
        }
    });
});